import React from 'react';
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";


const KeyValueHorizontal = (props) => {
    const {
        pairs,
        stakingBreakpoint,
        spacing,
        horizontalDivider,
        keyTextVariant,
        valueTextVariant,
        showKeyOnBottom,
        keyPadding,
        colors=[],
        onClick = f=>f
    } = props;

    const theme = useTheme();
    const shouldStack = useMediaQuery(theme.breakpoints.down(stakingBreakpoint || 'xs'));

    const showHorizontalDivider = horizontalDivider || false;
    const xsWidth = pairs.length > 0 ? Math.floor(12 / pairs.length) : 1;

    const isKeyOnBottom = !!showKeyOnBottom;
    const computedKeyPadding = Number.isFinite(keyPadding) ? keyPadding : 1;

    return (
        <Grid container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={spacing || 0}>
            {
                pairs.map(([k, v], i) => (
                    <Grid item container key={i} xs={shouldStack ? 12 : xsWidth}>
                        {
                            showHorizontalDivider &&
                            i === 0 &&
                            <Divider orientation="vertical" flexItem/>
                        }
                        <Box onClick={() => onClick(k)}
                             sx={{
                                 display: "flex",
                                 flexDirection: "column",
                                 justifyContent: "center",
                                 alignItems: "center",
                                 alignContent: "center",
                                 flexGrow: 1,
                             }}>
                            {
                                !isKeyOnBottom &&
                                <Box sx={{pb: computedKeyPadding}}>
                                    <Typography variant={keyTextVariant || "caption"} color={colors[i] ?? "textSecondary"}>
                                        {k}
                                    </Typography>
                                </Box>
                            }

                            <Typography variant={valueTextVariant || "body2"} sx={{fontWeight: 500}} color={colors[i] ?? ""}>
                                {v}
                            </Typography>

                            {
                                isKeyOnBottom &&
                                <Box sx={{pt: computedKeyPadding}}>
                                    <Typography variant={keyTextVariant || "caption"} color={colors[i] ?? "textSecondary"} align="center" >
                                        {k}
                                    </Typography>
                                </Box>
                            }
                        </Box>
                        {
                            showHorizontalDivider &&
                            <Divider orientation="vertical" flexItem/>
                        }
                    </Grid>
                ))
            }
        </Grid>
    )
};

KeyValueHorizontal.propTypes = {
    pairs: PropTypes.arrayOf(PropTypes.arrayOf).isRequired,
    stakingBreakpoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    spacing: PropTypes.number,
    horizontalDivider: PropTypes.bool,
    keyTextVariant: PropTypes.string,
    valueTextVariant: PropTypes.string,
    showKeyOnBottom: PropTypes.bool,
    keyPadding: PropTypes.number,
    colors: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func  // a function that is called when a key is clicked (the key is passed as argument)
};

export default KeyValueHorizontal;